(() => {
  function init(root) {
    if (root.dataset.journalReady) return;
    root.dataset.journalReady = 'true';
    const filters = Array.from(root.querySelectorAll('[data-journal-filter]'));
    const grid = root.querySelector('[data-journal-grid]');
    let cards = Array.from(root.querySelectorAll('[data-journal-category]'));
    const count = root.querySelector('[data-journal-count]');
    const loading = root.querySelector('[data-journal-loading]');
    const status = root.querySelector('[data-journal-status]');
    const retry = root.querySelector('[data-journal-retry]');
    let category = 'all';
    let running = false;
    const storyKey = card => card.querySelector('h3 a').getAttribute('href');
    const seen = new Set(cards.map(storyKey));
    function applyFilter() {
      let visible = 0;
      cards.forEach(card => {
        card.hidden = category !== 'all' && card.dataset.journalCategory !== category;
        if (!card.hidden) visible++;
      });
      count.textContent = `${visible} ${visible === 1 ? 'story' : 'stories'}`;
    }
    filters.forEach(link => link.addEventListener('click', event => {
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      category = link.dataset.journalFilter;
      filters.forEach(filter => {
        if (filter === link) filter.setAttribute('aria-current', 'true');
        else filter.removeAttribute('aria-current');
      });
      applyFilter();
    }));
    async function loadAll() {
      if (running) return;
      const missing = filters.filter(filter => Number(filter.dataset.journalTotal) > cards.filter(card => card.dataset.journalCategory === filter.dataset.journalFilter).length);
      if (!missing.length) return;
      running = true;
      loading.hidden = false;
      retry.hidden = true;
      status.textContent = 'Loading all stories…';
      try {
        for (const filter of missing) {
          let next = filter.getAttribute('href');
          const visited = new Set();
          while (next && root.isConnected) {
            const url = new URL(next, window.location.href);
            url.hash = '';
            if (url.origin !== window.location.origin || visited.has(url.href)) throw new Error('Invalid archive page');
            visited.add(url.href);
            const response = await fetch(url.href, { credentials: 'same-origin' });
            if (!response.ok) throw new Error('Archive unavailable');
            const page = new DOMParser().parseFromString(await response.text(), 'text/html');
            const feed = page.querySelector('[data-category-feed]');
            const found = feed?.querySelectorAll('[data-category-story]');
            if (!found?.length) throw new Error('No stories returned');
            if (!root.isConnected) return;
            for (const original of found) {
              const key = storyKey(original);
              if (seen.has(key)) continue;
              const card = document.importNode(original, true);
              card.dataset.journalCategory = filter.dataset.journalFilter;
              card.removeAttribute('data-category-story');
              card.querySelectorAll('img').forEach(img => { img.loading = 'lazy'; });
              cards.push(card);
              seen.add(key);
            }
            cards.sort((a, b) => b.querySelector('time').dateTime.localeCompare(a.querySelector('time').dateTime));
            grid.replaceChildren(...cards);
            applyFilter();
            next = feed.querySelector('[data-category-next]')?.getAttribute('href');
          }
          if (cards.filter(card => card.dataset.journalCategory === filter.dataset.journalFilter).length < Number(filter.dataset.journalTotal)) throw new Error('Incomplete archive');
        }
        status.textContent = `All ${cards.length} stories loaded.`;
      } catch (error) {
        status.textContent = 'Some stories could not be loaded. Try again to see the rest.';
        retry.hidden = false;
      } finally {
        running = false;
      }
    }
    retry.addEventListener('click', loadAll);
    loadAll();
  }
  document.querySelectorAll('[data-journal]').forEach(init);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-journal]').forEach(init);
  });
})();
